import Icon from '../components/Icon.vue'

Icon.register({
  taxi: {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M462 241.6L440 156.8C430.4 121.6 398.4 96 363.2 96H352V64C352 46.3 337.7 32 320 32H192C174.3 32 160 46.3 160 64V96H148.8C113.6 96 81.6 121.6 72 156.8L50 241.6C21.4 248 0 273.5 0 304V352C0 375.6 12.9 396 32 407.1V448C32 465.7 46.3 480 64 480H96C113.7 480 128 465.7 128 448V416H384V448C384 465.7 398.3 480 416 480H448C465.7 480 480 465.7 480 448V407.1C499.1 396 512 375.6 512 352V304C512 273.5 490.6 248 462 241.6zM96 352C78.3 352 64 337.7 64 320S78.3 288 96 288 128 302.3 128 320 113.7 352 96 352zM116.5 240L133.8 173.6C136 165.5 143.3 160 148.8 160H363.2C368.7 160 376 165.5 378.1 172.9L395.4 240H116.5zM416 352C398.3 352 384 337.7 384 320S398.3 288 416 288 448 302.3 448 320 433.7 352 416 352z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/taxi.js
// module id = B4D6
// module chunks = 144